export enum UserRole {
    ADMINISTRATOR = 'administrator',
}
